export const KOFI_URL = 'https://ko-fi.com/asafsaar';
export const GITHUB_RELEASES_URL = 'https://github.com/AsafSaar/SiliconVault-Desktop/releases/latest';
export const DESKTOP_PRICE = '$50';
